<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="close">
				<div class="modal-container" :class="classes" @click="shouldStopPropogation($event)">
					<div class="modal-header">
						<div class="carlsjr-top-image">
						</div>
						<template v-if="!isBM100">
							<div class="close-button">
								<span @click="close"
									role="button"
									tabindex="0"
									@keydown.enter="close"
									@keydown.space.prevent="close"
									:aria-label="$t('common.close')"
								>
									<v-icon class="exit-dialog-icon">close</v-icon>
									<span v-if="closeText && closeText.length">{{ closeText }}</span>
								</span>
							</div>
						</template>
						<v-layout row wrap class="headline-box">
							<v-flex xs10>
								<h2 class="header-text test" v-if="headerText && headerText.length">{{ headerText }}</h2>
							</v-flex>
						</v-layout>
					</div>
					<div class="modal-body">
						<template v-if="isBM100">
							<div v-if="showLogo" class="logo-style">	
								<img src="../../../static/tid100/images/modalTopLogo.png"/>
							</div>
							<div class="upsell-close">
								<div class="close-button close-button-sunset">
									<div @click="close" 
										class="close-button-body" 
										data-gtm-menu-item-close="true"
										role="button"
										tabindex="0"
										@keydown.enter="close"
										@keydown.space.prevent="close"
										:aria-label="$t('common.close')"
									>
										<img class="close-image" src="../../../static/tid100/images/icons/x-close.svg" alt=""/>
										<span v-if="closeText && closeText.length">{{ closeText }}</span>
									</div>
								</div>
								<hr>
							</div>
						</template>
						<slot></slot>
					</div>
					<hr class="display-none" />
					<div
						class="modal-footer"
						v-if="hasFooter"
						:class="{'pa-4': showLoginButton}"
					>
						<v-btn
							v-if="showLoginButton"
							class="v-btn green-btn btn-secondary"
							light
							small
							@click="redirectToLogin()"
						>
							{{ buttonNameToTranslationKey("showLoginButton") }}
						</v-btn>
						<template v-if="arrayButtons.length === 2">
							<v-btn class="Cancel-btn left no-right-margin modal-button secondary left-btn-color mr-1"
								   :class="{'flex margin-right17' :isBM100, 'copy-btn': copyConfirm}"
								   :disabled="arrayButtons[0].disabled"
								   :loading="arrayButtons[0].loading"
								   :key="arrayButtons[0].name"
								   @click="clickButton(arrayButtons[0].onClick)"
								   :style="arrayButtons[0].style"
								   small flat
								   data-cy="saveBtn"
							>
								<template v-if="isBM100">
									{{ $t(arrayButtons[0].text) || buttonNameToTranslationKey(arrayButtons[0].name)}}
								</template>
								<template v-else>
									{{ arrayButtons[0].name }}
								</template>
							</v-btn>
							<v-btn class="save-btn right no-left-margin modal-button primary btn-color"
								   :class="{'flex':isBM100}"
								   :disabled="arrayButtons[1].disabled"
								   :loading="arrayButtons[1].loading"
								   :key="arrayButtons[1].name"
								   @click="clickButton(arrayButtons[1].onClick)"
								   :style="arrayButtons[1].style"
								   small flat
								   data-cy="cancelBtn"
							>
								<template v-if="isBM100">
									{{ $t(arrayButtons[1].text) || buttonNameToTranslationKey(arrayButtons[1].name)}}
								</template>
								<template v-else>
									{{ arrayButtons[1].name }}
								</template>
							</v-btn>

						</template>

						<template v-else>
							<v-btn v-for="button in arrayButtons"
								   class="modal-button mx-1 quit-btn"
								   :style="button.style"
								   :disabled="button.disabled"
								   :loading="button.loading"
								   :key="button.name"
								   @click="clickButton(button.onClick)"
								   flat
							>
								<template v-if="isBM100">
									{{buttonNameToTranslationKey(button.text ? button.text : button.name)}}
								</template>
								<template v-else>
									{{ button.name }}
								</template>
							</v-btn>

						</template>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import appConfig from "../../appconfig";
	import {AUTH_FLOW_METHODS} from "../../libraries/globalTemplateSpecific/bm100/utils";
	import {SET_AUTH_FLOW_TRACKING} from "../../store/mutation-types";

	export default {
		name: "ModalComponent",
		props: ["headerText", "closeText", "onClose", "closeOnEsc", "buttons", "classes",
			"deleteConfirm", "nextConfirm", "copyConfirm", "selectedValue",
			"subscriptionDialogPause","subscriptionDialogCancel",
			"subscriptionDialogDowngrade", "subscriptionDialogUpgrade", "subscriptionDialogSwitchingPlansFailed",
			"showLoginButton", "removeItemFromBasket", "removeItemFromQuantity", "isProtectOrderFlow", "isSunsetShare", "showLogo"
		],
		data() {
			return {
				isFeedbackComponent: false
			};
		},
		methods: {
			redirectToLogin() {
				this.$store.commit(SET_AUTH_FLOW_TRACKING, AUTH_FLOW_METHODS.HISTORY);
				this.$emit("redirectToLogin");
			},
			shouldStopPropogation(event) {
				if (!this.isFeedbackComponent) {
					event.preventDefault();
					event.stopPropagation();
				}
			},
			buttonNameToTranslationKey(button){
				const self = this;
				switch(button){
				case "ok":
					if(self.deleteConfirm){
						return self.$t("utilityComponents.modalComponent.switchCase.delete");
					}
					if(self.copyConfirm){
						return self.$t("utilityComponents.modalComponent.switchCase.copy");
					}
					if(self.nextConfirm){
						return self.$t("utilityComponents.modalComponent.switchCase.next");
					}
					if(self.subscriptionDialogPause){
						return self.$t("utilityComponents.modalComponent.switchCase.confirmSubscriptionPause");
					}
					if(self.subscriptionDialogCancel){
						return self.$t("utilityComponents.modalComponent.switchCase.confirmSubscriptionCancel");
					}
					if(self.subscriptionDialogDowngrade) {
						return self.$t("utilityComponents.modalComponent.switchCase.confirmPlanDowngrade");
					}
					if(self.subscriptionDialogUpgrade) {
						return self.$t("utilityComponents.modalComponent.switchCase.confirmPlanUpgrade");
					}
					if(self.subscriptionDialogSwitchingPlansFailed) {
						return self.$t("utilityComponents.modalComponent.switchCase.tryAgainPlanSwitching");
					}
					if(self.removeItemFromBasket) {
						return self.$t("utilityComponents.modalComponent.switchCase.confirmRemoveItemFromBasket");
					}
					if(self.removeItemFromQuantity) {
						return self.$t("utilityComponents.modalComponent.switchCase.confirmRemoveItemFromQuantity");
					}
					if(self.isProtectOrderFlow) {
						return self.$t("utilityComponents.modalComponent.switchCase.confirmProtectOrderFlow");
					}
					if(self.isSunsetShare) {
						return self.$t("shopComponents.gt2.sunsetShare.confirmSunsetShare");
					}
					return self.$t("common.ok");
				case "cancel":
					if(self.subscriptionDialogCancel || self.subscriptionDialogPause){
						return self.$t("utilityComponents.modalComponent.switchCase.cancelSubscriptionPause");
					}
					if(self.removeItemFromBasket){
						return self.$t("utilityComponents.modalComponent.switchCase.cancelRemoveItemFromBasket");
					}
					if(self.removeItemFromQuantity){
						return self.$t("utilityComponents.modalComponent.switchCase.cancelRemoveItemFromQuantity");
					}
					if(self.isProtectOrderFlow){
						return self.$t("utilityComponents.modalComponent.switchCase.cancelProtectOrderFlow");
					}
					if(self.isSunsetShare) {
						return self.$t("shopComponents.gt2.sunsetShare.cancelSunsetShare");
					}
					return self.$t("utilityComponents.modalComponent.cancel");
				case "update": return self.$t("utilityComponents.modalComponent.update");
				case "Nej": return self.$t("common.no");
				case "Ja": return self.$t("common.yes");
				case "gem": return self.$t("utilityComponents.modalComponent.update");
				case "save": return self.$t("utilityComponents.modalComponent.save");
				case "preview": return this.$t("utilityComponents.modalComponent.preview");
				case "continue": return self.$t("utilityComponents.modalComponent.proceed");
				case "showLoginButton": return self.$t("shopComponents.gt2.loginPage.loginBtn");
				}

				return button;
			},
			close() {
				if (typeof this.onClose === "function" && !this.isFeedbackComponent) {
					this.onClose();
				}
			},
			escapeKeyListener: function (e) {
				const self = this;
				const close = typeof self.closeOnEsc === "undefined" ? true : !!self.closeOnEsc;
				if (close && e.keyCode === 27) {
					this.close();
				}
			},
			clickButton(buttonHandler) {
				if (typeof buttonHandler === "function") {
					buttonHandler();
				}
			},
			addModalPropagation (event) {
				this.isFeedbackComponent = event.detail;
			},
			removeModalPropagation (event) {
				this.isFeedbackComponent = event.detail;
			}
		},
		computed: {
			isBM100() {
				return appConfig.isBM100();
			},
			hasFooter() {
				return (typeof this.buttons === "object" && Object.keys(this.buttons).length > 0) || this.showLoginButton;
			},
			arrayButtons() {
				const self = this;

				if (self.buttons && Object.keys(self.buttons).length) {
					return Object.keys(self.buttons).map(key => {
						const returnValue = value => typeof self.buttons[key] === "object" && Object.prototype.hasOwnProperty.call(self.buttons[key], value)
							? self.buttons[key][value] : false;
						if(self.isBM100){
							return {
								name: key,
								onClick: typeof self.buttons[key] === "function" ? self.buttons[key] : returnValue("onClick"),
								disabled: key === "gem" ? (self.selectedValue === "" || self.selectedValue === undefined): returnValue("disabled"),
								loading: self.loading ? true: returnValue("loading"),
								text: returnValue("text") || "",
								style: returnValue("style") || undefined
							};
						}
						return {
							name: key,
							onClick: typeof self.buttons[key] === "function" ? self.buttons[key] : returnValue("onClick"),
							disabled: returnValue("disabled"),
							loading: returnValue("loading"),
							text: returnValue("text") || "",
							style: returnValue("style") || undefined
						};
					});
				} else {
					return [];
				}
			}
		},
		created: function () {
			const self = this;
			document.addEventListener("keyup", self.escapeKeyListener);
			window.addEventListener("isFeedbackDisplayed", self.addModalPropagation);
			window.addEventListener("removeFeedbackDisplayed", self.removeModalPropagation);
			// window.addEventListener("beforeunload", self.removeModalPropagation);
		},
		destroyed: function () {
			document.removeEventListener("keyup", this.escapeKeyListener);
		}
	};
</script>

<style lang="scss" scoped>
	.logo-style {
		text-align: center;
		img {
			max-height: 44px;
		}
	}
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		display: table;
		transition: opacity .3s ease;
	}

	.modal-wrapper {
		position: relative;
		height: 100vh;
		width: 100vw;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.modal-container {
		display: block;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		overflow: auto;
		text-align: left;
		-webkit-overflow-scrolling: touch;
		width: 540px;
	}

	.modal-header {
		margin-top: 0;
		font-weight: bold;
		.carlsjr-top-image {
			display: none;
		}
	}

	.modal-container.modal-small {
		display: block;
		top: auto;
		bottom: auto;
		left: auto;
		right: auto;
		max-height: 90vh;
		width: 30em;
		max-width: 90vw;
		-webkit-overflow-scrolling: touch;
		margin: 3em auto auto;
		position: relative;
	}

	.modal-container.modal-big {
		max-width: 1212px;
		width: 100%;
		position: relative;
		padding: 0 0 8px;
		overflow-x: hidden;
		//.modal-header {
		//	margin-top: -14px;
		//}
		/deep/ .v-input--selection-controls .v-label {
			margin-left: 0;
		}
		/deep/ .v-input.v-input--selection-controls .v-icon {
			left: auto !important;
			right: 0 !important;
		}
		/deep/ .v-input .v-input--checkbox {
			height: 42px;
			label {
				word-break: break-all;
				text-overflow: unset;
				white-space: normal;
				max-width: 80%;
				font-size: 12px;
				font-weight: normal;
				font-style: normal;
				font-stretch: normal;
				line-height: normal;
				letter-spacing: 0;
				color: #54585e;
			}
		}

		/deep/ .v-text-field__details {
			/*display: none;*/
		}

		.modal-footer {
			text-align: left;
			//margin: 0 46px;
			//padding: 8px 0 0;
		}

		.no-right-margin {
			margin: 6px 8px;
		}

		.no-left-margin {
			margin: 6px 8px;
		}

		.left {
			float: none !important;
		}

		.right {
			float: none !important;
		}

		.v-btn--small {
			height: 24px !important;
		}

	}

	hr {
		display: none;
	}

	.close-button {
		text-align: right;
	}

	.close-button span {
		cursor: pointer;
	}

	.modal-body {
		padding: 20px 0 0;
	}

	.modal-default-button {
		float: right;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-footer {
		text-align: center;
	}

	.tid2-style .modal-footer .modal-button.mx-1.v-btn {
		border: 2px solid #2391dd;
		color: #2391dd;
		border-radius: 50px;
	}

	.modal-footer .modal-button.mx-1.v-btn {
		display: inline-block;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal-container.capacity-rules-popup .v-btn--small {
		height: 40px !important;
		width: 110px;
		border-radius: 5px;
		font-size: 16px;
		font-weight: 500;
		font-style: normal;
		font-stretch: normal;
		line-height: 3;
		letter-spacing: normal;
		text-align: left;
		text-transform: capitalize;
	}
	.S9 .modal-container.modal-big .v-btn--small {
		height: 50px !important;
	}
	.modal-container.capacity-rules-popup /deep/.v-input.v-input--selection-controls .v-icon {
		left: auto !important;
		right: auto !important;
		font-size: 20px;
	}

	.modal-container.capacity-rules-popup /deep/ .v-input--selection-controls__ripple {
		margin-right: 0;
		height: 32px;
		width: 32px;
		right: 0;
	}

	.modal-container.capacity-rules-popup /deep/ .modal-button.secondary {
		background-color: #f8f8f8 !important;
	}

	.modal-container.capacity-rules-popup {
		background-color: #f8f8f8 !important;
		max-width: 1130px !important;
		min-width: 545px !important;
	}

	@media screen and (max-width: 600px) {

		.modal-container.capacity-rules-popup {
			max-width: 95vw !important;
			min-width: 200px !important;

			/deep/ .capacity-rule-popup-wrapper .v-stepper__wrapper {
				display: flex;
				flex-direction: column;
			}
			/deep/ .capacity-rule-popup-wrapper .capacity-rule-popup-radio-wrapper {
				width: 100%;
				padding: 40px 20px 20px;

				.capacity-rule-info-box {
					width: 100%;
					height: auto;
				}
			}

			/deep/ .capacity-rule-right-box {
				width: 100%;
				min-height: auto;
				padding: 0 10px;

				.v-picker {
					margin-left: 0;

					.v-picker__body {
						width: 100%!important;
					}
				}
			}

			.ingredient-overview-wrapper {
				padding: 2.5rem !important;
			}

			/deep/ .week-day-picker-wrapper {
				padding: 10px;
				width: 100%;

				.week-days-wrapper[data-v-0d025fee] {
					width: 100%;
					height: auto;
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
				}
			}
		}
	}

	.modal-container.capacity-rules-popup /deep/ .v-stepper__items {
		background-color: #f8f8f8;
	}

	.modal-container.capacity-rules-popup /deep/ .display-none {
		display: none !important;
	}

	.modal-container.capacity-rules-popup /deep/ .v-date-picker-header .v-btn .v-btn__content .v-icon {
		font-size: 36px;
		color:  #6a7783 !important;
	}

	.modal-container.capacity-rules-popup /deep/ .accent--text {
		font-size: 24px;
		color: #5294b6 !important;
		font-weight: normal;
	}

	.modal-container.capacity-rules-popup /deep/ .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
		color:  #6a7783 !important;
	}

	.modal-container.capacity-rules-popup /deep/ .add-limit-button-wrapper {
		.add-limit-button {
			.v-input.v-text-field--solo .v-text-field__slot {
				padding: 0 !important;
			}
		}
	}

	.modal-container.capacity-rules-popup /deep/ .v-input.v-text-field--solo .v-input__slot {
		height: 35px;
		min-height: 35px !important;
	}

	.modal-container.capacity-rules-popup /deep/ .v-input .v-input--checkbox, .modal-container.capacity-rules-popup /deep/ .v-text-field--solo {
		height: 35px;
		min-height: 35px;
	}

	.capacity-rules-popup .modal-body {
		margin-top: -51px;
	}

	.popup-video {
		max-width: 1024px !important;
		padding: 0 !important;
		overflow: hidden;
		hr {
			display: none !important;
		}
		.modal-header {
			margin-top: 0px !important;
		}
		.modal-body {
			padding: 0;
		}
		.modal-footer {
			display: none;
		}
	}

	/deep/ .primary {
		background-color: #5294b6 !important;
	}


	/deep/ .secondary {
		background-color: #ffffff !important;
		color: #4f93b7;
	}

	.modal-container.group-grid-dialog {
		width: 100vw;
		height: 95vh;
		max-width: 500px;
		margin: 0 auto;
		border-radius: 0;
		transform: translateY(100vh);
		transition: transform .3s cubic-bezier(.4,0,.2,1);
		box-shadow: none;
		padding: 0;
		overflow: visible;
		.modal-header {
			margin: 0;
		}
		.modal-body {
			padding: 0;
		}
	}

	.modal-container.group-grid-dialog.active {
		transform: translateY(2.5vh);
	}

	.group-grid-dialog .modal-body {
		overflow: auto;
		overflow-x: hidden;
		height: calc(95vh - 82px);
	}

	.modal-container.group-grid-dialog {
		.close-button {
			display: block;
			border-radius: 50%;
			background-color: #231f20;
			width: 40px;
			height: 40px;
			position: absolute;
			right: 0;
			text-align: center;
			padding-top: 5px;
			z-index: 10;
			top: -21px;
			span {
				display: block;
			}
			.v-icon {
				color: #ffc627;
				font-size: 30px;
				font-weight: 900;
			}
		}
		.close-button:active {
			background-color: #ffc627;
			.v-icon {
				color: #231f20;
			}
		}
	}

	.modal-container.shop-selection-warning {
		position: relative;
		max-width: 833px;
		width: 100%;
		min-height: 544px;
		height: auto;
		max-height: 90vh;
		padding: 0;
		box-shadow: -2px 4px 16px 0 rgba(0, 0, 0, 0.5);
		background-color: #222222;
		.modal-header {
			display: none;
		}
		.modal-body	{
			height: 100%;
			border-radius: 8px;
		}
		@media screen and (max-width: 600px) {
			margin: auto 10px;
			max-height: 86vh;
			min-height: 300px;
			.modal-body	{
				padding: 0;
			}
		}
	}

	.popup-small.approve-popup {
		width: 560px !important;
		min-height: 18rem;
		border-radius: 15px;
		/deep/ .header-sales {
			text-align: center;
			font-size: 20px !important;
			font-weight: 500;
			font-style: normal;
			font-stretch: normal;
			line-height: normal;
			padding: 0.75rem;
			background-color: #5294b6 !important;
		}

		/deep/ .text-sales {
			font-size: 18px;
			font-weight: 600;
			font-style: normal;
			font-stretch: normal;
			line-height: normal;
			letter-spacing: normal;
			color: #7e7e7e;
			padding: 0.5rem 2rem;
		}
		/deep/ .flex.xs12 {
			padding-left: 2rem;
			.icon {
				font-size: 28px;
			}
			label {
				font-size: 18px;
				font-weight: 600;
				font-style: normal;
				font-stretch: normal;
				line-height: normal;
				letter-spacing: normal;
				color: #979797;
				text-transform: uppercase;
				opacity: 0.59;
				padding: 3px 0 0 4px;
			}
			.input-group--selection-controls__ripple {
				left: 0;
				margin-right: 0;
				right: unset;
				height: 48px;
				width: 48px;
			}
		}
		.modal-footer {
			position: absolute;
			bottom: 0;
			width: 100%;
			margin: 0;
			padding: 0.5rem;
			.left {
				height: 40px !important;
				border-radius: 6px !important;
				border: solid 1px #979797 !important;
				font-size: 18px !important;
				text-transform: capitalize;
				background-color: #ffffff !important;
				color: #5294b6 !important;
				font-weight: 600;
				font-style: normal;
				font-stretch: normal;
				line-height: normal;
				letter-spacing: normal;
				margin-right: 4px !important;
			}
			.right {
				height: 40px !important;
				border-radius: 6px !important;
				background-color: #5294b6 !important;
				font-size: 18px !important;
				text-transform: capitalize;
				color: #ffffff !important;
				font-weight: 500;
				font-style: normal;
				font-stretch: normal;
				line-height: normal;
				letter-spacing: normal;
				margin-left: 4px !important;
			}
		}
	}

	.product-order-count-dialog {
		.close-button {
			display: none;
		}
		.modal-container {
			padding: 0;
			border-radius: 14px;
			width: 668px;
			margin: 8.5em auto auto;
		}
		.modal-body {
			padding: 0;
		}
	}

	.shopping-cart-step-shop {
		background-color: transparent;
		box-shadow: none;
		.modal-header {
			display: none;
		}
		.modal-body {
			text-align: center;
		}
	}

	.header-text-override {
		.header-text {
			font-size: 20px;
		}
	}

	@media screen and (max-width: 570px) {
		.modal-container.modal-big {
			.modal-footer {
				margin: 0 auto;
			}
		}
	}

	.cancel-btn{
		position: fixed;
	}
	.show-header{
		.modal-header{
			display: block;
			font-size: 26px;
		}
	}

</style>
